const IconYes = () => (
  <span className="icon icon-yes" />
);

const IconNo = () => (
  <span className="icon icon-no" />
);

export {
  IconYes,
  IconNo
};
